import config from '../config';
import { searchForm as SearchForm } from '@findologic/js-common';

export default new SearchForm(config);
